/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The charge type
 */
export enum ChargeType {
  NORMAL = 'NORMAL',
  FAST = 'FAST',
  RAPID = 'RAPID'
}
